"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _wrapperContext = _interopRequireDefault(require("../context/wrapper-context"));

var SupportMode = function SupportMode() {
  var wrapperContext = (0, _react.useContext)(_wrapperContext["default"]);
  var userFullName = wrapperContext.userFullName,
      authenticationMethod = wrapperContext.authenticationMethod;

  if (authenticationMethod && authenticationMethod.toLowerCase() === 'logintoken') {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "mr-2",
      style: {
        color: 'red'
      }
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: "d-block"
    }, "SUPPORT MODE"), /*#__PURE__*/_react["default"].createElement("span", {
      className: "d-block"
    }, userFullName));
  }

  return null;
};

var _default = SupportMode;
exports["default"] = _default;